
import React from "react";
import ReactDOM from 'react-dom'
import AbloyKeysApp from "../abloy_keys_react_app/AbloyKeysApp";

document.addEventListener('DOMContentLoaded', () => {
  const appContainer = document.querySelector('.abloy-app-container')
  if (!appContainer) {
    return
  }
  ReactDOM.render(
    <AbloyKeysApp />,
    appContainer,
  )
});
